import React from 'react'
import { useI18n } from '@ggs/i18n'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'

/**
 * @typedef {import('../../../definitions').ShowRoom} ShowRoom
 */

/**
 * @typedef {Object} ShowRoomProps
 * @property {ShowRoom} showRoom
 */

/**
 * Show room information.
 * @param {ShowRoomProps} props
 * @return {JSX.Element}
 */
export const ShowRoom = ({ showRoom }) => {
  const { t } = useI18n()
  if(showRoom.companyName === ''){
    return (null)
  }
  return (
    <Box className="show-room">
      <Typography variant={'h3'}>{t('Showroom')}</Typography>
      <div className="show-room__item">
        <div className="show-room__company">
          {showRoom.companyName}
        </div>
        <div className="show-room__address">
          {`${showRoom.address1} ${showRoom.address2}, ${showRoom.city}`}
        </div>
        <div className="show-room__address">
          {`${showRoom.stateProvince}, ${showRoom.zipPostal}`}
        </div>
        <div className="show-room__address">
          {showRoom.country}
        </div>
      </div>
    </Box>
  )
}
